import { H1 } from '@berlitz/globals'
import styled from 'styled-components'
import Avatar from '../../../components/Avatar'
import { WidgetCard } from '@components/Widgets/Common'

export const StyledAvatar = styled(Avatar)`
  margin-right: ${({ theme }) => theme.space.md};

  svg {
    font-size: ${({ theme }) => theme.fontSize.xs};
    color: white;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;

  div {
    p {
      font-size: ${({ theme }) => theme.fontSize.xs};
      color: ${({ theme }) => theme.palette.blueGray60};
    }

    ${H1} {
      line-height: 1;
    }
  }
`

export const SearchBar = styled.div`
  position: relative;
  margin: ${({ theme }) => `${theme.space.lg} 0`};

  p {
    padding: ${({ theme }) => theme.space.xs};
    position: absolute;
    z-index: 1;
  }
`

export const AlertWrapper = styled.div`
  & > div {
    width: 100%;
  }
  div > span:first-child {
    display: flex;
    width: 100%;
    align-items: center;
    & > div {
      width: 100%;
      & > span {
        display: flex;
        & > span:nth-child(2) {
          text-align: right;
          flex: 1;
        }
      }
    }
  }
`

export const WidgetWrapper = styled.div`
  display: flex;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    & > div > div > div {
      max-width: 100%;
      padding: 0;
      gap: 20px;
    }
    & > div > div > div > div > div {
      max-width: 100%;
    }
  }
`

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 500px 1fr 1fr;  
  gap: 24px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const LeftColumn = styled.div`
  grid-column: 1;
`;

export const RightColumns = styled.div`
  grid-column: 2 / -1;
  display: grid;
  column-gap: 24px;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-column: 1;
    grid-template-columns: 1fr;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {  
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1500px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1800px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (max-width: 568px) {
    margin-right: -0.75rem;
    margin-left: -0.75rem;
  }
`;

export const DashboardCard = styled(WidgetCard)`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.07);
  padding: ${({ theme }) => theme.space.lg || '24px'};
  height: 100%;
  transition: all 0.25s ease;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12);
  }
`;

export const ProfessionalCoursesCard = styled.div`
  [data-c-permission="c::dashboard::ProfessionalCourses"] {
    padding: 0 !important;
    max-width: 100%;
  }
  div[class^="Spacerstyle__SpacerNoChildren"] {
    display: none !important;
  }
`;
